import { InjectionToken, LOCALE_ID } from '@angular/core';
import { MetaDefinition } from '@angular/platform-browser';

import { SupportedLocale, environment } from '@env';

export const META_SETTINGS: InjectionToken<MetaSettings> = new InjectionToken('META_SETTINGS');

export type MetaSettings = {
  applicationName: string;
  titleSeparator: string;
  titlePositioning: 'append'|'prepend';
  defaultTitle: string|null;
  defaults: MetaDefinition|null;
};

export type MetaProvideSettings = {
  description: string;
  sitename: string;
  defaultTitle: string;
};

function getMetaSettings(localeId: SupportedLocale, settings: MetaProvideSettings): MetaSettings {
  let defaults: MetaDefinition = {
    'description': settings.description,
    'og:site_name': settings.sitename,
    'og:type': 'website',
    'og:locale': localeId,
    'og:locale:alternate': environment.supportedLocales.join(',')
  };

  if(typeof window !== 'undefined') {
    defaults = {
      ...defaults,
      'og:url': `https://${ window.location.host }`,
      'og:image': `https://${ window.location.host }/${ localeId }/assets/images/system-avatar.webp`
    };
  }

  return {
    applicationName: settings.sitename,
    titleSeparator: ' → ',
    titlePositioning: 'prepend',
    defaultTitle: settings.defaultTitle,
    defaults
  };
}

export function provideMeta(settings: MetaProvideSettings) {
  return {
    provide: META_SETTINGS,
    useFactory: (localeId: SupportedLocale) => getMetaSettings(localeId, settings),
    deps: [ LOCALE_ID ]
  };
}